const defaults = {
  formClass: '.chained-select',
  selectClass: '.select__control',
  hiddenDivs: '.chained-select__secondary-item',
  visibleClass: 'is-visible'
};

class ChainedSelect {
  constructor (element) {
    this.options = defaults;
    this.dropdown = element.querySelector(this.options.selectClass);
    this.hiddenDivs = element.querySelectorAll(this.options.hiddenDivs);
  }

  addEventListeners () {
    const hiddenDivs = this.hiddenDivs;
    const visibleItem = this.options.visibleClass;
    this.dropdown.addEventListener('change', function () {
      const currentItem = this.options[this.selectedIndex];
      const toggleOption = currentItem.classList.contains('js-chained-option');
      hideDivs();
      if (hiddenDivs.length && toggleOption) {
        hideDivs();
        const toggleDiv = document.getElementById(currentItem.value);
        toggleDiv.classList.add(visibleItem);
      }
    });

    function hideDivs () {
      if (hiddenDivs && hiddenDivs.length) {
        [...hiddenDivs].map(hiddenDiv => {
          hiddenDiv.classList.remove(visibleItem);
          const checkboxes = hiddenDiv.querySelectorAll('input[type="checkbox"]');
          [...checkboxes].map(checkbox => {
            checkbox.checked = false;
          });
        });
      }
    }
  }

  showInitial () {
    const visibleItem = this.options.visibleClass;
    const optionItems = this.dropdown.querySelectorAll('.js-chained-option');
    if (optionItems) {
      [...optionItems].forEach(optionItem => {
        if (optionItem.hasAttribute('selected')) {
          const initialDiv = document.getElementById(optionItem.value);
          initialDiv.classList.add(visibleItem);
        }
      });
    }
  }

  init () {
    this.showInitial();
    this.addEventListeners();
  }
}

export default ChainedSelect;
